import Vue from 'vue'
import Router from 'vue-router'
import cookie from 'js-cookie'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  fallback: false,
  routes: [
    {
      path: '/main',
      name: 'main',
      component: () => import('@/components/system/index'),
      children: [
        {
          name: 'attendance',
          path: '/attendance',
          component: () => import('@/components/attendance/attendance.vue'),
          props: true,
          meta: {
            title: '考勤'
          }
        },
        {
          name: 'attendance-report',
          path: '/attendance-report',
          component: () => import('@/components/attendance/attendance-report.vue'),
          props: true,
          meta: {
            title: '考勤报表'
          }
        },
        {
          name: 'process-startInstance',
          path: '/process-startInstance',
          component: () => import('@/components/process/process-startInstance.vue'),
          meta: {
            title: '流程列表'
          },
          props: true
        },
        {
          name: 'process-runtime',
          path: '/process-runtime/:taskId?',
          component: () => import('@/components/process/process-runtime.vue'),
          meta: {
            title: '流程'
          }
        },
        {
          name: 'process-doingTasks',
          path: '/process-doingTasks',
          component: () => import('@/components/process/process-doingTasks.vue'),
          meta: {
            title: '待办流程'
          }
        },
        {
          name: 'process-dispose',
          path: '/process-dispose/:flag',
          component: () => import('@/components/process/process-dispose.vue')
        },
        {
          name: 'process-doneTasks',
          path: '/process-doneTasks',
          component: () => import('@/components/process/process-doneTasks.vue'),
          meta: {
            title: '已办流程'
          }
        },
        {
          name: 'process-hasInstances',
          path: '/process-hasInstances',
          component: () => import('@/components/process/process-hasInstances.vue'),
          meta: {
            title: '已发流程'
          }
        },
        {
          name: 'process-view',
          path: '/process-view/:instanceId',
          component: () => import('@/components/process/process-view.vue'),
          meta: {
            title: '查看流程'
          }
        },
        {
          name: 'report-runtime',
          path: '/report-runtime/:id',
          component: () => import('@/components/report/report-runtime.vue'),
          props: true,
          meta: {
            title: '报表'
          }
        },
        {
          name: 'form-runtime',
          path: '/form-runtime/:id',
          component: () => import('@/components/form/runtime/form-runtime.vue'),
          props: true
        },
        {
          name: 'childrenReport-runtime',
          path: '/childrenReport-runtime/:id/:dataKey/:dataValue',
          component: () => import('@/components/report/childrenReport-runtime.vue'),
          props: true,
          meta: {
            title: '子表'
          }
        },
        {
          name: 'android-service',
          path: '/android-service',
          component: () => import('@/components/system/androidService/android-service.vue'),
          props: true,
          meta: {
            title: '我的客服'
          }
        },
        {
          name: 'question',
          path: '/question',
          component: () => import('@/components/system/androidService/question.vue'),
          props: true,
          meta: {
            title: '我的客服-帮助'
          }
        },
        {
          name: 'details',
          path: '/details',
          component: () => import('@/components/system/androidService/details.vue'),
          props: true,
          meta: {
            title: '我的客服'
          }
        },
        {
          name: 'formRuntimeOutsideChain',
          path: '/mobile/tt/:id/:tenantId/:tenantName',
          component: () => import('@/components/form/runtime/form-runtime-outside-chain.vue'),
          props: true
        },
        {
          name: 'appRuntime',
          path: '/app-runtime/:id',
          component: () => import('@/components/app/runtime/app-runtime.vue'),
          props: true,
          meta: {
            title: 'App页面'
          }
        },
        {
          name: 'AppPreview',
          path: '/app-preview/:id',
          component: () => import('@/components/app/runtime/app-preview.vue'),
          props: true,
          meta: {
            title: 'App预览页面'
          }
        },
        /* onecar */
        {
          name: 'onecar-login',
          path: '/onecar/login',
          component: () =>
            import('@/components/custom/onecar/weiXin/login.vue'),
          meta: { title: '个人登录' }
        },
        {
          name: 'onecar-index',
          path: '/onecar/index',
          component: () =>
            import('@/components/custom/onecar/weiXin/index.vue'),
          meta: { title: '个人中心' }
        },
        {
          name: 'onecar-orderCheck',
          path: '/onecar/orderCheck',
          component: () =>
            import('@/components/custom/onecar/weiXin/orderCheck.vue'),
          meta: { title: '预约检测' }
        },
        {
          name: 'onecar-submitSuccess',
          path: '/onecar/submitSuccess',
          component: () =>
            import('@/components/custom/onecar/weiXin/submitSuccess.vue'),
          meta: { title: '提交成功' }
        },
        {
          name: 'onecar-myOrderList',
          path: '/onecar/myOrderList',
          component: () =>
            import('@/components/custom/onecar/weiXin/myOrderList.vue'),
          meta: { title: '我的订单' }
        },
        {
          name: 'onecar-checkListDetail',
          path: '/onecar/checkListDetail',
          component: () =>
            import('@/components/custom/onecar/weiXin/checkListDetail.vue'),
          meta: { title: '检测订单详情' }
        },
        {
          name: 'onecar-reportCheck',
          path: '/onecar/reportCheck',
          component: () =>
            import('@/components/custom/onecar/weiXin/reportCheck.vue'),
          meta: { title: '检测报告' }
        }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  // 判断路由是否有cookie参数
  let tenantId = to.query.tenantId
  let tokenType = to.query.tokenType
  let accessToken = to.query.accessToken
  if (tenantId && tokenType && accessToken) {
    cookie.set('tenantId', tenantId)
    cookie.set('token', tokenType + ' ' + accessToken)
    sessionStorage.setItem('appToken', tokenType + ' ' + accessToken)
  }
  /* 路由发生变化修改页面title */
  if (to.meta.title && to.meta.title !== '流程') {
    document.title = to.meta.title
  }
  next()
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js